import React from "react";
import { Checkbox } from "@fluentui/react";
import CompanySectionCard from "@/screen/Companies/components/CompanySectionCard";
import { CompanyOnboardingStrings } from "@/screen/Companies/companyOnboarding.strings";
import { Field, FieldGrid, Input, ReadingNotice, Select } from "@/screen/Companies/Styles/CompanyFormFieldStyles";
import type { RepresentativeFormData } from "@/screen/Companies/CompanyRepresentative/companyRepresentativeForm";

interface RepresentativeIdDataSectionProps
{
    formData: RepresentativeFormData;
    /** Aviso cuando la lectura del DNI no ha podido sacar todos los datos. */
    readingWarning: string | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onPermanentIdExpirationChange: (checked: boolean) => void;
}

// Tarjeta 2: datos leídos del DNI, editables por si la lectura no es correcta o no se ha podido hacer
const RepresentativeIdDataSection: React.FC<RepresentativeIdDataSectionProps> = ({ formData, readingWarning, onChange, onPermanentIdExpirationChange }) =>
{
    return(
        <CompanySectionCard number={2} title={CompanyOnboardingStrings.idDataTitle} description={CompanyOnboardingStrings.idDataDescription}>
            {readingWarning && <ReadingNotice role="status">{readingWarning}</ReadingNotice>}
            <FieldGrid>
                <Field>
                    <span>Nombre <b>*</b></span>
                    <Input type="text" name="firstName" value={formData.firstName} onChange={onChange} maxLength={50} autoComplete="off" />
                </Field>
                <Field>
                    <span>Primer apellido <b>*</b></span>
                    <Input type="text" name="lastName" value={formData.lastName} onChange={onChange} maxLength={50} autoComplete="off" />
                </Field>
                <Field>
                    <span>Segundo apellido</span>
                    <Input type="text" name="secondLastName" value={formData.secondLastName} onChange={onChange} maxLength={50} autoComplete="off" />
                </Field>
                <Field>
                    <span>Tipo de documento <b>*</b></span>
                    <Select name="idType" value={formData.idType} onChange={onChange}>
                        <option value="DNI">DNI</option>
                        <option value="NIE">NIE</option>
                    </Select>
                </Field>
                <Field>
                    <span>Nº de documento <b>*</b></span>
                    <Input type="text" name="idDocument" value={formData.idDocument} onChange={onChange} maxLength={15} placeholder="12345678Z" autoComplete="off" />
                </Field>
                <Field>
                    <span>Fecha de nacimiento <b>*</b></span>
                    <Input type="date" name="birthday" value={formData.birthday} onChange={onChange} />
                </Field>
                <Field>
                    <span>Fecha de caducidad {!formData.hasPermanentIdExpiration && <b>*</b>}</span>
                    <Input type="date" name="idExpiration" value={formData.idExpiration} onChange={onChange} disabled={formData.hasPermanentIdExpiration} />
                    <Checkbox label={CompanyOnboardingStrings.permanentIdExpiration} checked={formData.hasPermanentIdExpiration} onChange={(ev, checked) => onPermanentIdExpirationChange(!!checked)} />
                </Field>
            </FieldGrid>
        </CompanySectionCard>
    );
};

export default RepresentativeIdDataSection;
